const bigData = () => import('Views/browseData/browse-data');

export default[
  { path: '/browse-data', component: bigData },
];



// WEBPACK FOOTER //
// ./src/router/browseData.js